import { TextField, InputLabel } from '@material-ui/core';
import React, { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import styled from 'styled-components';
import { get } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import { getDecisionDocuments } from 'containers/LawyerLegalProceedingsPage/Contestation/utils';
import ContestationDecisionForm from 'containers/LawyerLegalProceedingsPage/Contestation/ContestationDecisionForm';

export const StyledInputLabel = styled(InputLabel)`
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
  color: black;
  box-shadow: 0px 1px 3px #000;
  height: 36px;
  margin-right: 20px;
`;

export const StyledTextField = styled(TextField)`
  margin-left: 18px;
  margin-top: 6px;
`;
export interface ContestionDecisionProps {
  intl: IntlShape;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  documentId: any;
  setDocumentId: Function;
  judgementOnMerits: any;
  listings: Listings;
  claimNumber?: string;
  contestationId?: number;
  requestUploadContestationDocument?: Function | undefined;
  contestationDecisionNatureId: number;
  isLawyer?: boolean;
  handleSuccessCallback?: Function;
  isCivilProceeding?: boolean;
  disabled?: boolean;
  requestGetDocByDocumentumId: Function;
}
const ContestionDecision: FC<ContestionDecisionProps> = props => {
  const [contestationDocs, setContestationDocs] = React.useState<null | any>(
    [],
  );
  return (
    <ContestationDecisionForm
      decisionDocuments={getDecisionDocuments(
        get(props.judgementOnMerits, 'jom.jmc.jmcd', []),
        get(props.listings, 'judgementOnMeritsContestationNature'),
      )}
      contestationDocs={contestationDocs}
      setContestationDocs={setContestationDocs}
      listings={props.listings}
      judgementOnMerits={props.judgementOnMerits}
      uploadDocument={props.uploadDocument}
      uploadedDocument={props.uploadedDocument}
      resetUploadedDocument={props.resetUploadedDocument}
      setDocumentId={props.setDocumentId}
      documentId={props.documentId}
      claimNumber={props.claimNumber}
      isLawyer={props.isLawyer}
      contestationId={props.contestationId}
      requestUploadContestationDocument={
        props.requestUploadContestationDocument
      }
      handleSuccessCallback={props.handleSuccessCallback}
      isCivilProceeding={props.isCivilProceeding}
      disabled={props.disabled}
      requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
    />
  );
};

export default injectIntl(ContestionDecision);
